module.exports = __webpack_public_path__ + "static/Services-web-full-b26816d6684b50879cda1c2cdfb5d59c.png";